module.exports = __webpack_public_path__ + "static/media/APIStep3.953be0ef.svg";